import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var GlobeIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,2.001c-3.86,0 -7,3.14 -7,6.999c0,3.86 3.14,7 7,7c3.86,0 7,-3.14 7,-7c0,-3.859 -3.14,-6.999 -7,-6.999Zm5.97,6.999c0,1.366 -0.463,2.625 -1.236,3.631c-0.219,-0.17 -0.451,-0.632 -0.233,-1.11c0.221,-0.481 0.279,-1.595 0.228,-2.029c-0.048,-0.433 -0.274,-1.477 -0.885,-1.487c-0.611,-0.009 -1.031,-0.211 -1.394,-0.935c-0.753,-1.508 1.414,-1.798 0.661,-2.632c-0.211,-0.235 -1.3,0.964 -1.46,-0.633c-0.01,-0.115 0.099,-0.286 0.245,-0.464c2.365,0.795 4.074,3.031 4.074,5.659Zm-6.79,-5.911c-0.143,0.279 -0.52,0.392 -0.749,0.601c-0.498,0.451 -0.713,0.389 -0.981,0.822c-0.271,0.433 -1.143,1.056 -1.143,1.37c0,0.313 0.441,0.682 0.661,0.611c0.22,-0.073 0.801,-0.069 1.142,0.051c0.342,0.121 2.854,0.242 2.054,2.365c-0.254,0.675 -1.366,0.562 -1.662,1.679c-0.044,0.164 -0.198,0.865 -0.208,1.094c-0.018,0.354 0.251,1.69 -0.091,1.69c-0.343,0 -1.267,-1.195 -1.267,-1.411c0,-0.217 -0.239,-0.976 -0.239,-1.626c0,-0.65 -1.107,-0.64 -1.107,-1.504c0,-0.778 0.6,-1.166 0.465,-1.54c-0.132,-0.372 -1.186,-0.385 -1.626,-0.431c0.768,-1.991 2.574,-3.469 4.751,-3.771Zm-1.058,11.577c0.359,-0.19 0.395,-0.435 0.72,-0.447c0.372,-0.017 0.675,-0.145 1.094,-0.238c0.372,-0.081 1.038,-0.459 1.623,-0.507c0.495,-0.04 1.469,0.026 1.732,0.503c-0.944,0.627 -2.077,0.993 -3.291,0.993c-0.656,0 -1.287,-0.108 -1.878,-0.304Z"
  }));
});
GlobeIcon.displayName = 'GlobeIcon';
export default GlobeIcon;